import urlParse from 'url-parse';

const getURLParam = (param) => {
  const url = urlParse(global.window.location.href, true);
  const query = url.query;
  return query[param];
};

export default getURLParam;



// WEBPACK FOOTER //
// ./src/controllers/Session/getURLParam.js